import Toast from "components/cms/Toast";
import SectionCard from "components/cms/SectionCard";
import { FieldRow, FileInput, GroupBox, TextInput } from "components/cms/fields";
import useCmsPage from "hooks/useCmsPage";
import { addBasic, getBasic, updateBasic } from "api/basic";
import { emptyBasic } from "utils/defaults";

const HEADER_KEYS = [
  "headerLogo",
  "headerCtaText",
  "headerCtaLink",
  "productMenu1Title",
  "productMenu2Title",
  "productMenu3Title",
];

export default function HeaderPage() {
  const {
    form,
    setField,
    frMap,
    loading,
    toast,
    setToast,
    saveSection,
    savingSection,
    isSectionDirty,
  } = useCmsPage({
    load: getBasic,
    create: addBasic,
    update: updateBasic,
    empty: emptyBasic,
    mapResponse: (res) => res.data?.data || res.data?.info,
  });

  if (loading) {
    return <p className="mt-5 text-gray-600">Loading Header…</p>;
  }

  return (
    <div className="mt-3">
      <Toast toast={toast} onClose={() => setToast(null)} />

      <SectionCard
        title="Header"
        description="Site logo, header CTA, and Products dropdown labels"
        onSave={() => saveSection("header", HEADER_KEYS)}
        saving={savingSection === "header"}
        canSave={isSectionDirty(HEADER_KEYS)}
      >
        <FileInput
          label="Header logo"
          path="headerLogo"
          form={form}
          setField={setField}
        />
        <FieldRow>
          <TextInput
            label="CTA text"
            path="headerCtaText"
            form={form}
            setField={setField}
            frMap={frMap}
          />
          <TextInput
            label="CTA link"
            path="headerCtaLink"
            form={form}
            setField={setField}
          />
        </FieldRow>
        <GroupBox title="Products submenu">
          <FieldRow>
            <TextInput
              label="Item one (/products)"
              path="productMenu1Title"
              form={form}
              setField={setField}
              frMap={frMap}
            />
            <TextInput
              label="Item two (/products/two)"
              path="productMenu2Title"
              form={form}
              setField={setField}
              frMap={frMap}
            />
          </FieldRow>
          <TextInput
            label="Item three (/products/three)"
            path="productMenu3Title"
            form={form}
            setField={setField}
            frMap={frMap}
          />
        </GroupBox>
      </SectionCard>
    </div>
  );
}
